// extracted by mini-css-extract-plugin
export default {"box":"icon-module__box___5342cd","svg":"icon-module__svg___e5e6ec"};